export const GET = Object.freeze({
  REQUEST: 'role/GET_REQUEST',
  SUCCESS: 'role/GET_SUCCESS',
  ERROR: 'role/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'role/FIND_REQUEST',
  SUCCESS: 'role/FIND_SUCCESS',
  ERROR: 'role/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'role/CREATE_REQUEST',
  SUCCESS: 'role/CREATE_SUCCESS',
  ERROR: 'role/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'role/UPDATE_REQUEST',
  SUCCESS: 'role/UPDATE_SUCCESS',
  ERROR: 'role/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'role/DELETE_REQUEST',
  SUCCESS: 'role/DELETE_SUCCESS',
  ERROR: 'role/DELETE_ERROR',
});

export const GET_ROLES_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_ROLE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_ROLE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_ROLE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_ROLE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
